import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../common/Modal';
import AddForm from './AddForm';

export default function AddModal({
  classroomsPath, closeModal, createPath, hasStrictPasswordRequirement, modalIsOpen, updateTable
}) {
  return (
    <Modal
      closeModal={closeModal}
      headerText="Add Student"
      isOpen={modalIsOpen}
    >
      <AddForm
        classroomsPath={classroomsPath}
        closeModal={closeModal}
        createPath={createPath}
        hasStrictPasswordRequirement={hasStrictPasswordRequirement}
        updateTable={updateTable}
      />
    </Modal>
  );
}

AddModal.propTypes = {
  classroomsPath: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  createPath: PropTypes.string.isRequired,
  hasStrictPasswordRequirement: PropTypes.bool.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  updateTable: PropTypes.func.isRequired
};
